module.exports = __webpack_public_path__ + "media/images/home-icon-68b5da3336ecc69ea195a0364670bb4f5e1a94d3e9208443014b0e478f25ac13.svg";